import { xcss } from '@atlaskit/primitives';

export const ThemeImageLabelContainer = xcss({
  display: 'flex',
  alignItems: 'center',
  gap: 'space.150',
});

export const ThemeItemLabelContainer = xcss({
  display: 'flex',
  alignItems: 'center',
  gap: 'space.100',
});

export const FeedbackContainer = xcss({
  display: 'flex',
  alignItems: 'center',
  paddingInline: 'space.300',
  paddingBlock: 'space.100',
});
